import Link from "next/link";
import {getNavPath} from "../shared/navigateUtil";
import styled from "styled-components";
import {signOut} from "next-auth/react";
import {useRouter} from "next/router";
import {useMessages} from "../hooks/useMessages";
import {getTheme} from "../shared/themeUtils";
import {request} from "../shared/httpInterceptor";
import {useCountryLang} from "../hooks/useCountryLang";
import {useQuery} from "@tanstack/react-query";
import {IAccountMenu, IAccountMenuEntry} from "../interfaces/IAccountMenu";
import {useAtom} from "jotai";
import {nextSessionAtom} from "../store/sessionAtom";

const MenuContain = styled.div`
  height: 100%;

  .account-nav {
    padding: 0;
    margin: 0;
    list-style: none;
    width: 100%;

    li {
      text-decoration: none;
      font-weight: bold;
      font-size: ${getTheme("fontSizes.medium")};
        margin-bottom: ${getTheme("space.2")};
      cursor: pointer;

      &:hover {
        color: ${getTheme("colors.link")};
      }
    }
  }

  .preview {
      color: ${getTheme("colors.internal")};
  }
    
  .active {
    padding: ${getTheme('space.1')};
    background: ${getTheme("colors.background")};
    border-radius: ${getTheme('borderRadius')};
    position: relative;
    left: -${getTheme('space.1')};
  }
`

type AccountPropsType = {
  className?: string;
}

export const fetchMenuEntries = async (countryLang: string | null, session: any, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/customer/init`,
    method: 'get',
    session: session,
    host: host
  };
  
  if (context) {
    requestConfig.context = context;
  }
  
  const res = await request(requestConfig);
  return res.data;
}

const AccountMenu = (props: AccountPropsType) => {
  const router = useRouter()
  const messagesQuery = useMessages()
  const [sessionAtom] = useAtom(nextSessionAtom)
  const {session, status} = sessionAtom;
  const countryLang = useCountryLang()

  const menuEntriesQuery = useQuery<IAccountMenu>(
    ["accountMenu", countryLang],
    () => fetchMenuEntries(countryLang, session), 
    {
      enabled: countryLang != null && status == "authenticated",
      refetchOnWindowFocus: false,
      staleTime: Infinity,  // Data will never become stale automatically
      cacheTime: Infinity,  // Cache will never be garbage collected
    }
  );

  const handleSignOut = async () => {
    await request({url: `/${countryLang}/logout`, method: "POST"})
    await signOut({
      redirect: false
    })

    router.reload()
  }

  return (
    <MenuContain className={props.className}>
      {messagesQuery.data &&
        <ul className="account-nav">

          {menuEntriesQuery.data &&
            <>
              {menuEntriesQuery.data?.entries?.map((entry: IAccountMenuEntry) => {
                return (<li className={entry.preview ? 'preview' : (router.asPath.includes(entry.path) ? 'active' : '')} key={entry.path}>
                  <Link href={getNavPath(router, entry.path)}>
                    <span>{entry.title}</span>
                  </Link>
                </li>)
              })}
            </>
          }

          <div className="separator"></div>
          <li onClick={handleSignOut}>{messagesQuery.data.messages["logout"]}</li>
        </ul>
      }
    </MenuContain>
  )
}

export default AccountMenu;